import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import { hexaToRgba } from '../../components/functions';

export default (props) => {
  return (
    <Container
      className={'c_PageHeader dark'}
      fluid={true}
      style={{
        height: 'calc(100vh - 110px)',
        maxHeight: '360px',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {props.image && <BackgroundImage props={props.image} />}

      <BackgroundCover props={{ color: '17285A', opacity: 0.85 }} />

      {props.title && (
        <Row>
          <Container
            style={{
              position: 'absolute',
              bottom: '40px',
              left: '50%',
              transform: 'translate(-50%)',
            }}
          >
            <Row className={'justify-content-start'}>
              <Col xs={12} md={8} xl={6}>
                <h1>{props.title}</h1>
                <p>{props.description.toUpperCase()}</p>
              </Col>
            </Row>
          </Container>
        </Row>
      )}
    </Container>
  );
};


const BackgroundImage = ({ props }) => {
  return (
   
    <GatsbyImage
      image={props.childImageSharp.gatsbyImageData}
      imgStyle={{ objectFit: 'cover' }}
      alt=""
      style={{
        position: 'absolute !important',
        minWidth: '100%',
        minHeight: '100%',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        
      }}
    />
  );
};
const BackgroundCoverStyled = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
const BackgroundCover = ({ props }) => {
  return (
    <BackgroundCoverStyled
      style={{ backgroundColor: hexaToRgba(props) }}
    />
  );
};
